export * from './variantSelectorMapper';
